import React from "react";

const Title = ({ title, className }) => {
  return (
    <div className="relative mr-2 ">
      <span className="w-2 h-2 rounded-full bg-Main absolute top-1/2 -translate-y-1/2 right-0"></span>
      <div className={`text-start mb-3 mr-3 ${className} text-xl font-bold`}>
        {title}
      </div>
    </div>
  );
};

export default Title;
